import { MouseSensor, PointerSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { useMemo } from 'react';
export const useDndSensors = () => {
  // Require moving 1px to remove spam click lag
  const options = useMemo(() => ({
    activationConstraint: {
      distance: 1
    }
  }), []);
  const pointerSensor = useSensor(PointerSensor, options);
  const mouseSensor = useSensor(MouseSensor, options);
  const touchSensor = useSensor(TouchSensor);
  const sensors = useSensors(pointerSensor, mouseSensor, touchSensor);
  return sensors;
};